"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory('$mdUtil', UtilFactory);
function UtilFactory($timeout, $rootScope) {
  // Setup some core variables for the processTemplate method

  var $mdUtil = {
    dom: {},
    /**
     * supplant() method from Crockford's `Remedial Javascript`
     * Equivalent to use of $interpolate; without dependency on
     * interpolation symbols and scope. Note: the '{<token>}' can
     * be property names, property chains, or array indices.
     */
    supplant: function supplant(template, values, pattern) {
      pattern = pattern || /\{([^\{\}]*)\}/g;
      return template.replace(pattern, function (a, b) {
        var p = b.split('.'),
          r = values;
        try {
          for (var s in p) {
            if (p.hasOwnProperty(s)) {
              r = r[p[s]];
            }
          }
        } catch (e) {
          r = a;
        }
        return typeof r === 'string' || typeof r === 'number' ? r : a;
      });
    },
    /**
     * Create an implicit getter that caches its `getter()`
     * lookup value
     */
    valueOnUse: function valueOnUse(scope, key, getter) {
      var value = null,
        args = Array.prototype.slice.call(arguments);
      var params = args.length > 3 ? args.slice(3) : [];
      Object.defineProperty(scope, key, {
        get: function get() {
          if (value === null) value = getter.apply(scope, params);
          return value;
        }
      });
    },
    // Stop watchers and events from firing on a scope without destroying it,
    // by disconnecting it from its parent and its siblings' linked lists.
    disconnectScope: function disconnectScope(scope) {
      if (!scope) {
        return;
      }

      // we can't destroy the root scope or a scope that has been already destroyed
      if (scope.$root === scope) {
        return;
      }
      if (scope.$$destroyed) {
        return;
      }
      var parent = scope.$parent;
      scope.$$disconnected = true;

      // See Scope.$destroy
      if (parent.$$childHead === scope) parent.$$childHead = scope.$$nextSibling;
      if (parent.$$childTail === scope) parent.$$childTail = scope.$$prevSibling;
      if (scope.$$prevSibling) scope.$$prevSibling.$$nextSibling = scope.$$nextSibling;
      if (scope.$$nextSibling) scope.$$nextSibling.$$prevSibling = scope.$$prevSibling;
      scope.$$nextSibling = scope.$$prevSibling = null;
    },
    // Undo the effects of disconnectScope above.
    reconnectScope: function reconnectScope(scope) {
      if (!scope) {
        return;
      }

      // we can't disconnect the root node or scope already disconnected
      if (scope.$root === scope) {
        return;
      }
      if (!scope.$$disconnected) {
        return;
      }
      var child = scope;
      var parent = child.$parent;
      child.$$disconnected = false;
      // See Scope.$new for this logic...
      child.$$prevSibling = parent.$$childTail;
      if (parent.$$childHead) {
        parent.$$childTail.$$nextSibling = child;
        parent.$$childTail = child;
      } else {
        parent.$$childHead = parent.$$childTail = child;
      }
    },
    /**
     * Alternative to $timeout calls with 0 delay.
     * nextTick() coalesces all calls within a single frame
     * to minimize $digest thrashing
     *
     * @param callback
     * @param digest
     * @returns {*}
     */
    nextTick: function nextTick(callback, digest, scope) {
      //-- grab function reference for storing state details
      var nextTick = $mdUtil.nextTick;
      var timeout = nextTick.timeout;
      var queue = nextTick.queue || [];

      //-- add callback to the queue
      queue.push(callback);

      //-- set default value for digest
      if (digest == null) {
        digest = true;
      }

      //-- store updated digest/queue values
      nextTick.digest = nextTick.digest || digest;
      nextTick.queue = queue;

      //-- either return existing timeout or create a new one
      return timeout || (nextTick.timeout = $timeout(processQueue, 0, false));

      /**
       * Grab a copy of the current queue
       * Clear the queue for future use
       * Process the existing queue
       * Trigger digest if necessary
       */
      function processQueue() {
        var skip = scope && scope.$$destroyed;
        var queue = !skip ? nextTick.queue : [];
        var digest = !skip ? nextTick.digest : null;
        nextTick.queue = [];
        nextTick.timeout = null;
        nextTick.digest = false;
        queue.forEach(function (callback) {
          callback();
        });
        if (digest) {
          $rootScope.$digest();
        }
      }
    }
  };
  return $mdUtil;
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/ripple/ripple-utils.js
// module id = 2989
// module chunks = 13